import React, { useLayoutEffect } from 'react';

/**
 * Ensure mobile Safari uses the device viewport, not its 980px desktop fallback.
 * Widths belong to CSS (100dvw).  Do not derive layout width from screen.width,
 * which can differ from visualViewport/innerWidth when zoomed or browser UI changes.
 * This component does not alter application state, callbacks, or navigation.
 */
export default function MobileViewport() {
  useLayoutEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return undefined;

    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
      viewportMeta = document.createElement('meta');
      viewportMeta.setAttribute('name', 'viewport');
      document.head.appendChild(viewportMeta);
    }
    viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, viewport-fit=cover');

    // A CSS unit updates automatically on resize/rotation and doesn't freeze
    // page width to a stale or undersized JavaScript measurement.
    const root = document.documentElement;
    root.style.removeProperty('--tbp-mobile-screen-width');
    root.style.setProperty('--tbp-mobile-screen-width', '100dvw');
    return () => {
      // Do not erase the shared width on route navigation: other pages use it.
    };
  }, []);
  return null;
}
